import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import { FaChevronDown } from 'react-icons/fa';
import './Hero.css';


const Hero = () => {

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Hero Content */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="container mx-auto px-6 relative z-10 max-w-6xl"
      >
        <div className="text-center md:text-left">
          <motion.h1
            variants={itemVariants}
            className="font-poppins font-bold tracking-tight text-white mb-10"
          >
            <span className="block text-xl md:text-2xl font-medium tracking-normal text-gray-400 mb-6">
              Hi, I'm
            </span>
            <span className="block text-6xl md:text-8xl lg:text-9xl leading-[0.95] gradient-text animate-gradient">
              Manish Tandurkar
            </span>
          </motion.h1>

          <motion.div
            variants={itemVariants}
            className="flex flex-col sm:flex-row justify-center md:justify-start gap-4 mb-16"
          >
            <Link to="projects" smooth={true} duration={500} offset={-80}>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-white text-night hover:bg-gray-200 px-8 py-4 rounded-full font-semibold transition-all duration-300 w-full sm:w-auto"
              >
                View My Work
              </motion.button>
            </Link>
            <Link to="contact" smooth={true} duration={500} offset={-80}>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="border border-white/20 text-white hover:bg-white/10 hover:border-white/40 backdrop-blur-sm px-8 py-4 rounded-full font-semibold transition-all duration-300 w-full sm:w-auto"
              >
                Get In Touch
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </motion.div>

      {/* Scroll Down Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10"
      >
        <Link to="about" smooth={true} duration={500} offset={-80}>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="cursor-pointer text-white/50 hover:text-white transition-colors"
          >
            <FaChevronDown className="text-3xl" />
          </motion.div>
        </Link>
      </motion.div>
    </section>
  );
};

export default Hero;
